export default __webpack_public_path__ + "static/media/bad.316aeffd.svg";